"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KineticScroller_1 = require("../../components/KineticScroller");
var _globals_1 = require("../_globals");
new KineticScroller_1.KineticScroller(_globals_1.root, {
    scrollElement: '.carousel-opinie-teasers',
    leftSelector: '.carousel-opinie-arrow-left',
    rightSelector: '.carousel-opinie-arrow-right'
});
new KineticScroller_1.KineticScroller(_globals_1.root, {
    scrollElement: '.carousel-program-teasers',
    leftSelector: '.carousel-program-arrow-left',
    rightSelector: '.carousel-program-arrow-right'
});
new KineticScroller_1.KineticScroller(_globals_1.root, {
    scrollElement: '.carousel-bnr-podcasts-teasers',
    leftSelector: '.carousel-bnr-podcasts-arrow-left',
    rightSelector: '.carousel-bnr-podcasts-arrow-right'
});
new KineticScroller_1.KineticScroller(_globals_1.root, {
    scrollElement: '.carousel-experts-podcasts-teasers',
    leftSelector: '.carousel-experts-podcasts-arrow-left',
    rightSelector: '.carousel-experts-podcasts-arrow-right'
});
